var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

var SettingsAboutComponent = require('../components/settings-about.jsx');

var SettingsAbout = createClass({

  render() {
    return (
      <div className='vf-bg-white-color full-viewport-height'>
        <SettingsAboutComponent />
      </div>
    );
  }

});

export default SettingsAbout;
